import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 ps-5" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-header border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_account_profile_details",
    "aria-expanded": "true",
    "aria-controls": "kt_account_profile_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Research Activities")
    ])
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_5 = { class: "row mb-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 1. What is your research question(s)? ", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, "2. What is the research design? (Definition: The research design of human subject research refers to the overall plan or strategy outlining how data will be collected and analyzed to address specific research questions or hypotheses.) ", -1)
const _hoisted_10 = { class: "col-lg-12 fv-row" }
const _hoisted_11 = { class: "fs-6" }
const _hoisted_12 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, "2.1 Other Research Design Description ", -1)
const _hoisted_14 = { class: "col-lg-12 fv-row" }
const _hoisted_15 = { class: "fs-6" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, "3. Is an intervention a part of the research? (Definition: \"intervention\" refers to any deliberate action, treatment, manipulation, or condition introduced by the researcher to study its effects on the participants' health, behavior, or outcomes. E.g., education session, training, treatment, etc.) ", -1)
const _hoisted_18 = { class: "col-lg-12 fv-row" }
const _hoisted_19 = { class: "fs-6" }
const _hoisted_20 = {
  key: 1,
  class: "row mb-7"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, "3.1 Please summarize the intervention", -1)
const _hoisted_22 = { class: "col-lg-12 fv-row" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "row mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 4. List and describe all outcome measures that will be used to gather data from subjects: (Definition: \"Outcome Measures\" in human subject research are tools, such as surveys, questionnaires, interviews, or physiological assessments, used to gather information from subjects for the purpose of study analysis and interpretation). Attach all outcome measures/data collection instruments to this application. ", -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "row mb-7" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Research Method ", -1)
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Research Procedure ", -1)
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { class: "row mb-7" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Research Purpose ", -1)
const _hoisted_35 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoteSection = _resolveComponent("NoteSection")!
  const _component_ViewActions = _resolveComponent("ViewActions")!
  const _component_Documents = _resolveComponent("Documents")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NoteSection, { type: _ctx.modalNoteType }, null, 8, ["type"]),
    _createVNode(_component_ViewActions, {
      "route-name": "view-subject-define",
      "route-name-edit": "edit-research-activities"
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentResearch.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", {
                  class: "fw-bold fs-6",
                  innerHTML: _ctx.currentResearch.data.question
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentResearch.data.researchDesign), 1)
                ])
              ]),
              (_ctx.currentResearch.data.researchDesign=='Others, please specify')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.currentResearch.data.otherResearchDesign), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.currentResearch.data.isAnyIntervention == "1"? "Yes":"No"), 1)
                ])
              ]),
              (_ctx.currentResearch.data.isAnyIntervention=='1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        class: "fs-6",
                        innerHTML: _ctx.currentResearch.data.sumarizeIntervention
                      }, null, 8, _hoisted_23)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("span", {
                  class: "fw-bold fs-6",
                  innerHTML: _ctx.currentResearch.data.outcomes
                }, null, 8, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", {
                  class: "fw-bold fs-6",
                  innerHTML: _ctx.currentResearch.data.method
                }, null, 8, _hoisted_29)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("span", {
                  class: "fw-bold fs-6",
                  innerHTML: _ctx.currentResearch.data.procedure
                }, null, 8, _hoisted_32)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("span", {
                  class: "fw-bold fs-6",
                  innerHTML: _ctx.currentResearch.data.purpose
                }, null, 8, _hoisted_35)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Documents, {
        classification: "Research-Activites",
        hiddeDelete: "true"
      })
    ])
  ], 64))
}